import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function AwardsBanner() {
  const [AwardsBanner, setAwardsBanner] = useState({});

  useEffect(() => {
    const fetchAwardsBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/awards/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setAwardsBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAwardsBanner();
  }, []);

  return (
      <div
        className="common-banner-sec common-flex-center awards-banner"
        style={{
          backgroundImage: `url(${
            apiUrl.apiUrl + `/` + AwardsBanner.banner_image
          })`,
        }}
      >
        <div className="overlay"></div>
        <Container fluid>
          <Row className="common-flex-center">
            <Col md={8}>
              <div className=" ">
                <h1 className="common-head whiteColor">
                  {AwardsBanner.banner_title}
                </h1>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
  );
}

export default AwardsBanner;
